<template>
  <div
    id="export-wallet-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-[600px] max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-semibold text-base uppercase">Export wallet</h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent rounded-lg text-sm w-6 h-6 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
            @click="this.modal.hide()"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div class="p-4 space-y-4 lg:space-y-6">
          <div class="relative flex items-center gap-6">
            <label class="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                class="sr-only peer"
                :checked="this.showName"
                v-model="showName"
              />
              <span
                class="ms-3 text-sm font-semibold text-gray-300 mr-2 uppercase"
              >
                Show name
              </span>
              <div
                class="relative w-11 h-6 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-800 bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all border-gray-600 peer-checked:bg-blue-600"
              ></div>
            </label>
            <label class="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                class="sr-only peer"
                :checked="this.showAddress"
                v-model="showAddress"
              />
              <span
                class="ms-3 text-sm font-semibold text-gray-300 mr-2 uppercase"
              >
                Show address
              </span>
              <div
                class="relative w-11 h-6 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-800 bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all border-gray-600 peer-checked:bg-blue-600"
              ></div>
            </label>
            <label class="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                class="sr-only peer"
                :checked="this.showPrivateKey"
                v-model="showPrivateKey"
              />
              <span
                class="ms-3 text-sm font-semibold text-gray-300 mr-2 uppercase"
              >
                Show private key
              </span>
              <div
                class="relative w-11 h-6 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-800 bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all border-gray-600 peer-checked:bg-blue-600"
              ></div>
            </label>
          </div>
          <textarea
            readonly
            rows="12"
            class="p-2.5 w-full text-sm bg-transparent rounded-xl border border-gray-400 focus:outline-none focus:ring-0"
            :value="this.text"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ExportWalletModal",
  data() {
    return {
      modal: null,
      showName: true,
      showAddress: true,
      showPrivateKey: true,
    };
  },
  computed: {
    ...mapGetters("wallet", ["wallets"]),
    open() {
      return this.$store.state.exportWallet.open;
    },
    text() {
      if (this.showName && this.showAddress && this.showPrivateKey) {
        return this.wallets
          .map(
            (wallet) =>
              `${wallet.name}: ${wallet.address}\n${wallet.privateKey}`
          )
          .join("\n\n");
      }
      if (this.showName && this.showAddress) {
        return this.wallets
          .map((wallet) => `${wallet.name}: ${wallet.address}`)
          .join("\n\n");
      }
      if (this.showName && this.showPrivateKey) {
        return this.wallets
          .map((wallet) => `${wallet.name}\n${wallet.privateKey}`)
          .join("\n\n");
      }
      if (this.showAddress && this.showPrivateKey) {
        return this.wallets
          .map((wallet) => `${wallet.address}\n${wallet.privateKey}`)
          .join("\n\n");
      }

      if (this.showPrivateKey) {
        return this.wallets.map((wallet) => `${wallet.privateKey}`).join("\n");
      }

      return this.wallets.map((wallet) => `${wallet.address}`).join("\n");
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
  methods: {
    ...mapActions("exportWallet", ["show", "hide"]),
  },
  mounted() {
    this.modal = new Modal(document.getElementById("export-wallet-modal"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      onHide: () => {
        this.hide();
      },
    });
  },
  beforeUnmount() {
    this.hide();
  },
};
</script>
